/**
 * Topic not found component for Moderation Topic Detail Page
 */

import { Button, ButtonType, Heading, Text } from '@soteria/design-system-ve';

import * as styles from '../ModerationTopicDetailPage.css';

import * as notFoundStyles from './ModerationTopicNotFound.css';

interface ModerationTopicNotFoundProps {
  onBackClick: () => void;
}

export function ModerationTopicNotFound({ onBackClick }: ModerationTopicNotFoundProps) {
  return (
    <div className={styles.contentSection}>
      <div className={styles.contentContainer}>
        <div className={notFoundStyles.container}>
          <Heading className={notFoundStyles.heading} level="h2">
            Topic Not Found
          </Heading>
          <Text className={notFoundStyles.description}>The moderation topic you're looking for doesn't exist or you don't have access to it.</Text>
          <Button buttonType={ButtonType.Primary} onClick={onBackClick}>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
